import React from "react";
import { toast } from "react-toastify";
// Common Components
import { Button, DynamicDropdown, DynamicMultiSelectDropdown } from "src/Components";
// Requests
import {
  getAssetClassInstrumentsDropDown,
  getAssetTypesDropDown,
  updateAssetType,
} from "src/Requests/assetClass";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  /** ISIN list pre-selected in the modal (multi-selected rows) */
  initialInstrumentIds?: string[];
  onSuccess: () => void;
}

const EditAssetClassModal: React.FC<IProps> = ({
  initialInstrumentIds = [],
  onSuccess,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [instrumentIds, setInstrumentIds] =
    React.useState<string[]>(initialInstrumentIds);
  const [assetType, setAssetType] = React.useState<string>("");

  const submitHandler = () => {
    if (!instrumentIds.length) {
      toast.error("حداقل یک نماد انتخاب کنید");
      return;
    }
    if (assetType === "") {
      toast.error("طبقه دارایی را انتخاب کنید");
      return;
    }
    setLoading(true);
    updateAssetType({ instrumentIds, assetType: Number(assetType) })
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          onSuccess();
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col justify-start items-start gap-4 min-w-[360px] p-2">
      <h4 className="font-bold">ویرایش طبقه دارایی</h4>
      <DynamicMultiSelectDropdown
        dropdown={{ name: "instrumentIds", placeholder: "نماد", extraLabel: true }}
        getData={getAssetClassInstrumentsDropDown}
        onChange={(_, value) => setInstrumentIds(value)}
        value={instrumentIds}
        withTagBox
      />
      <DynamicDropdown
        dropdown={{
          name: "assetType",
          placeholder: "طبقه دارایی",
          extraLabel: true,
        }}
        getData={getAssetTypesDropDown}
        onChange={(_, value) => setAssetType(value)}
        value={assetType}
      />
      <Button
        text="ثبت"
        onClick={submitHandler}
        variant="contained"
        loading={loading}
      />
    </div>
  );
};

export default EditAssetClassModal;
